const breakpointWidth = {
    small: "500px",
    medium: "800px",
    normal: "1024px",
    large: "1400px",
};
const breakpoint = {
    smallUp: `min-width: ${breakpointWidth.small}`,
    smallDown: `max-width: ${breakpointWidth.small}`,
    mediumUp: `min-width: ${breakpointWidth.medium}`,
    mediumDown: `max-width: ${breakpointWidth.medium}`,
    normalDown: `max-width: ${breakpointWidth.normal}`,
    normalUp: `min-width: ${breakpointWidth.normal}`,
    largeDown: `max-width: ${breakpointWidth.large}`,
    largeUp: `min-width: ${breakpointWidth.large}`,
};

export { breakpoint, breakpointWidth };
